export function mergeWorkspaceSales(remoteSales = [], localSales = []) {
  const merged = new Map();

  for (const sale of localSales || []) {
    if (sale?.id) merged.set(sale.id, sale);
  }
  for (const sale of remoteSales || []) {
    if (sale?.id) merged.set(sale.id, sale);
  }

  return Array.from(merged.values()).sort((left, right) => (
    String(right.createdAtIso || right.createdAt || "").localeCompare(
      String(left.createdAtIso || left.createdAt || ""),
    )
  ));
}
